import React from 'react';
import styled from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AnalyticsTracker from './components/AnalyticsTracker';
import ConsentManager from './components/ConsentManager';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import WhyByteForge from './components/WhyByteForge';
import Projects from './components/Projects';
import Dynamics365 from './components/Dynamics365';
import Prozessoptimierung from './components/Prozessoptimierung';
import IndividuelleSoftwareentwicklung from './components/IndividuelleSoftwareentwicklung';
import Automatisierung from './components/Automatisierung';
import DevOps from './components/DevOps';
import KI from './components/KI';
import Projektmanagement from './components/Projektmanagement';
import Desktopanwendungen from './components/Desktopanwendungen';
import AppEntwicklung from './components/AppEntwicklung';
import Contact from './components/Contact';
import Impressum from './components/Impressum';
import Datenschutz from './components/Datenschutz';
import Footer from './components/Footer';
import ProjectDetail from './components/ProjectDetail';
import SEO from './components/SEO';

const AppContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'Byte Forge',
  legalName: 'Byte Forge UG (haftungsbeschränkt)',
  url: 'https://www.byte-forge.it',
  logo: 'https://www.byte-forge.it/images/logo.png',
  image: 'https://www.byte-forge.it/images/logo.png',
  email: 'thomas.gross@byte-forge.it',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Alte Gärtnerei 4',
    postalCode: '04425',
    addressLocality: 'Taucha',
    addressCountry: 'DE',
  },
  description:
    'Byte Forge entwickelt individuelle Softwarelösungen, Apps und Desktop-Anwendungen und ist spezialisiert auf Microsoft Dynamics 365, Automatisierung und Künstliche Intelligenz.',
  areaServed: 'DE',
  knowsAbout: [
    'Individuelle Softwareentwicklung',
    'Microsoft Dynamics 365',
    'App-Entwicklung',
    'Desktop-Anwendungen',
    'Prozessautomatisierung',
    'Künstliche Intelligenz',
    'Projektmanagement',
  ],
  sameAs: [],
};

const HomePage: React.FC = () => (
  <>
    <SEO
      title="Individuelle Softwareentwicklung & Dynamics 365 Experten"
      description="Byte Forge entwickelt maßgeschneiderte Softwarelösungen, Apps und Desktop-Anwendungen. Spezialisiert auf Microsoft Dynamics 365, Automatisierung und KI – für mehr Effizienz und Wachstum."
      path="/"
      keywords="Softwareentwicklung, Dynamics 365, individuelle Software, Automatisierung, Künstliche Intelligenz, App-Entwicklung, Byte Forge"
      jsonLd={organizationJsonLd}
    />
    <Hero />
    <Services />
    <About />
    <WhyByteForge />
    <Projects />
    {/*<Dynamics365 />*/}
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <AppContainer>
        <AnalyticsTracker />
        <ConsentManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projekte/:slug" element={<ProjectDetail />} />
            <Route path="/dynamics365" element={<Dynamics365 />} />
            <Route path="/prozessoptimierung" element={<Prozessoptimierung />} />
            <Route path="/individuelle-softwareentwicklung" element={<IndividuelleSoftwareentwicklung />} />
            <Route path="/automatisierung" element={<Automatisierung />} />
            <Route path="/devops" element={<DevOps />} />
            <Route path="/ki" element={<KI />} />
            <Route path="/projektmanagement" element={<Projektmanagement />} />
            <Route path="/desktop-anwendungen" element={<Desktopanwendungen />} />
            <Route path="/app-entwicklung" element={<AppEntwicklung />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </main>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
